export const hasLowerUpperCase = (string) => {
  const test = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).+$")
  const subject = typeof string === "string" ? string : String(string)
  return Boolean(test.exec(subject))
}

export const lengthCheck = (string, min, max) => {
  const subject = typeof string === "string" ? string : String(string)
  return Boolean(subject !== "undefined" && subject.length >= min && subject.length <= max)
}

export const hasNumber = (string) => {
  const test = /^(?=.*\d).+$/
  const subject = typeof string === "string" ? string : String(string)
  return Boolean(subject.match(test))
}

export const hasSymbol = (string) => {
  const test = /^(?=.*(_|[^\w])).+$/
  const subject = typeof string === "string" ? string : String(string)
  return Boolean(subject.match(test))
}



// WEBPACK FOOTER //
// ./src/AtomicUtils/string.js